import useSWR from 'swr'
import { api } from '@lib/orpc-client'

const useKYCDetail = () => {
    const { data, isLoading, error } = useSWR(
        'walletV2.kyc.myDetail',
        () => api.walletV2.kyc.myDetail({}),
        {
            dedupingInterval: 10000 // 10 seconds
        }
    )

    const levelNumber: number = data?.kyc_level.match(/\d+/)?.[0] || 0

    return {
        data,
        isLoading,
        error,
        levelNumber
    }
}

export default useKYCDetail
